// HubSpot's consent banner for our account, the same as pfida.com's. Pfida only (caller checks tenant).
// Public pages load HubSpot's full script; signed in pages load only the banner, because the full script
// tracks the page (Legal: no tracking script on pages with account or investment details).

import { type HubSpotWindow, pushToHubSpot } from '@repo/utils';

import { injectScript } from '../injectScript';
import { isPublicPath } from '../publicPages';

export const HUBSPOT_SCRIPT_URL = 'https://js-eu1.hs-scripts.com/145177032.js';
export const HUBSPOT_SCRIPT_ID = 'hs-script-loader';
// the banner alone sends no page views; it sets its own cookie domain (.pfida.com)
export const HUBSPOT_BANNER_URL = 'https://js-eu1.hs-banner.com/v2/145177032/banner.js';
export const HUBSPOT_BANNER_ID = 'cookieBanner-145177032';

/** Loads HubSpot once: the full script on a public page, only the banner elsewhere. Never throws. */
export function loadHubSpot(pathname: string = window.location.pathname): boolean {
  try {
    if (document.getElementById(HUBSPOT_SCRIPT_ID) || document.getElementById(HUBSPOT_BANNER_ID)) {
      return false;
    }
    if (isPublicPath(pathname)) {
      injectScript(HUBSPOT_SCRIPT_URL, { id: HUBSPOT_SCRIPT_ID, defer: true });
      return true;
    }
    // the settings HubSpot's full script queues before the banner
    pushToHubSpot(window as HubSpotWindow, ['addEnabledFeatureGates', []], ['setBusinessUnitId', 0]);
    injectScript(HUBSPOT_BANNER_URL, {
      id: HUBSPOT_BANNER_ID,
      defer: true,
      attributes: { 'data-cookieconsent': 'ignore', 'data-hs-ignore': 'true' },
    });
    return true;
  } catch {
    return false;
  }
}

/** Reopens HubSpot's banner so the visitor can change or withdraw their choice. Never throws. */
export function showCookieSettings(): void {
  try {
    pushToHubSpot(window as HubSpotWindow, ['showBanner']);
  } catch {
    // the banner must never break the app
  }
}
